import { call, put, take } from 'redux-saga/effects';

import { GO_TO_CFI_PAGE } from './actions';
import { notifications, SET_ISLOADING } from 'PipeRouter';

import { goToCFI } from 'services/learnkit';


function* goToCfiPage() {
  while (true) {
    const { data:cfi } = yield take(GO_TO_CFI_PAGE);

    yield put(notifications(SET_ISLOADING, true));
    yield call(goToCFI, cfi);
  }
}


export default goToCfiPage;
